import { render } from "./WantToBuy.vue?vue&type=template&id=24782c98&scoped=true&ts=true&lang=pug"
import script from "./WantToBuy.vue?vue&type=script&lang=ts&setup=true"
export * from "./WantToBuy.vue?vue&type=script&lang=ts&setup=true"

import "./WantToBuy.vue?vue&type=style&index=0&id=24782c98&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24782c98"]])

export default __exports__